import { render, staticRenderFns } from "./Sentence.vue?vue&type=template&id=04d23aa4&scoped=true&"
import script from "./Sentence.vue?vue&type=script&lang=js&"
export * from "./Sentence.vue?vue&type=script&lang=js&"
import style0 from "./Sentence.vue?vue&type=style&index=0&id=04d23aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d23aa4",
  null
  
)

export default component.exports